// 📦 Imports
import React, { useRef, useEffect } from "react";
import DisLatexRender from "../../../../../layout/DisLatexRender";

export default function EquationBox({ question, answer, setAnswer, submitAnswer, setHasSubmitted, hasSubmitted, hasSubmittedStep1, setHasSubmittedStep1, finalFeedback, step1Feedback, handleNext, hasOutreached, setHasOutreached, handleNextStep, questionNumber }) {

  const xInputRef = useRef(null);
  const valInputRef = useRef(null);

// Handle inputfield focus
useEffect(() => {
  if (question && !hasSubmittedStep1) {
    xInputRef.current?.focus();
  }
}, [question, hasSubmittedStep1]);
  
  // Load question
  if (!question) {
    return (
      <div className="flex justify-center items-center h-full">
        <img
          src="/images/logo.png"
          alt="Loading..."
          className="w-16 h-16 animate-spin"
        />
      </div>
    );
  }

  //  Rendered view
  let renderedView;

  if (hasSubmitted && finalFeedback.correct) {
    console.log("Hello");
    //Final correct answer
    renderedView = (
      <>
        <DisLatexRender math={`\\begin{align*} ${question.question} \\\\ ${step1Feedback?.correct_s1_answer} \\\\ x &=${finalFeedback.correct_answer} \\end{align*}`} />
        <div className="flex items-center justify-center space-x-2 ml-12 -mt-16">
        </div>
        <input
          type="text"
          style={{ position: "absolute", opacity: 0, pointerEvents: "none" }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleNext();
            }
          }}
          autoFocus
        />
      </>
    );
  } else if (hasSubmitted && !finalFeedback.correct) {

    // First step correct, second input wrong
    renderedView = (
      <>
        <DisLatexRender math={`\\begin{align*} ${question.question} \\\\ ${step1Feedback?.correct_s1_answer} \\\\ x &=\\textcolor{red}{${answer.final_answer}} \\end{align*}`} />
        <div className="flex items-center justify-center space-x-2 ml-12 -mt-16">
          <input
          type="text"
          style={{ position: "absolute", opacity: 0, pointerEvents: "none" }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setHasSubmitted(false);
              setAnswer("")
              
            }
          }}
          autoFocus
          />
        </div>
      </>
    );
  } else if (hasSubmittedStep1 && step1Feedback?.correct) {
    console.log("correct_s1_answer:", step1Feedback?.correct_s1_answer);
    console.log("answer", answer);
    console.log("feedback", step1Feedback?.correct)

    // First step correct, second input needed
    renderedView = (
      <>
        <DisLatexRender math={`\\begin{align*} ${question.question} \\\\ ${step1Feedback?.correct_s1_answer} \\end{align*}`} />
        <div className="flex items-center justify-center space-x-2 ml-12 -mt-16">
          <DisLatexRender math={`x =`} />
          <input
            ref={valInputRef}
            type="text"
            inputMode="text"
            pattern="-?[0-9]*"
            value={answer.final_answer || ""}
            onChange={(e) => setAnswer({ ...answer, final_answer: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();

                const finalAnswer = parseFloat(answer.final_answer);

                if (answer.final_answer === '' || isNaN(finalAnswer)) {
                  alert('Indtast hel tal i feltet.');
                  return;
                }

                // Both values are valid numbers
                submitAnswer();
                setHasSubmitted(true);
                setHasOutreached(false);
              }
            }}
            className="border border-black rounded-lg w-[70px] p-2 ml-2"
            autoFocus
          />
        </div>
      </>
    );
  } else if (hasSubmittedStep1 && !step1Feedback?.correct) {
    console.log("correct_s1_answer:", step1Feedback?.correct_s1_answer);
    console.log("answer", answer);
    console.log("feedback", step1Feedback?.correct)
    console.log("hasSubmittedStep1", hasSubmittedStep1);
    console.log("hasSubmitted", hasSubmitted);

    // Show error in step 1
    renderedView = (
      <>
        <DisLatexRender math={`\\begin{align*} ${question.question} \\\\\\textcolor{red}{ ${answer.x}} x &= \\textcolor{red}{${answer.val}}\\end{align*}`} />
        <input
          type="text"
          style={{ position: "absolute", opacity: 0, pointerEvents: "none" }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setHasSubmittedStep1(false);
              setHasOutreached(false);
              setAnswer("")
            }
          }}
          autoFocus
        />
      </>
    );
  } else {
    console.log("answer", answer);
    console.log("hasSubmittedStep1", hasSubmittedStep1);
    console.log("hasSubmitted", hasSubmitted);

    // First input fields
    renderedView = (
      <>
        <DisLatexRender math={`\\begin{align*} ${question.question} \\end{align*}`} />
        <div className="flex items-center justify-center space-x-2 mr-10 -mt-16">
        <input
          ref={xInputRef}
          type="text"
          inputMode="text"
          pattern="-?[0-9]*"
          value={answer.x || ""}
          onChange={(e) => setAnswer({ ...answer, x: e.target.value })}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              valInputRef.current?.focus();
            }
          }}
          className="border border-0.5 border-gray-400 bg-white/0 text-right rounded-lg w-[77px] p-2"
          autoFocus
        />
        <DisLatexRender math={`x=`} />
        <input
          ref={valInputRef}
          type="text"
          inputMode="text"
          pattern="-?[0-9]*"
          value={answer.val || ""}
          onChange={(e) => setAnswer({ ...answer, val: e.target.value })}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();

              const xVal = parseFloat(answer.x);
              const valVal = parseFloat(answer.val);

              if (answer.x === '' || isNaN(xVal) || answer.val === '' || isNaN(valVal)) {
                alert('Indtast hele tal i begge felter.');
                return;
              }

              // Both values are valid numbers
              submitAnswer();
              setHasSubmittedStep1(true);
            }
          }}
          className="border border-0.5 border-gray-400 bg-white/0 rounded-lg w-[77px] p-2"
        />
        </div>
      </>
    );
  }
    
    return (
        <div className="graphPaperBox">
        {question && (
          <div className="text-4xl">
            {renderedView}
          </div>
        )}
        </div>
    );
}
